import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { useState } from 'react';

import { usePostPaRequestMutation } from 'store/api/intakeCaseApi';

interface CreateEpaDialogProps {
    isOpen: boolean;
    onClose: () => void;
    intakeCaseId: string;
}

export const CreateEpaDialog = ({ isOpen, onClose, intakeCaseId }: CreateEpaDialogProps) => {
    const [postPaRequest] = usePostPaRequestMutation();
    const [isSubmitting, setIsSubmitting] = useState(false);
    return (
        <WarningDialog
            dialogTitle="Confirm Create New PA Request"
            isOpen={isOpen}
            primaryButtonLabel="Yes, Create New PA Request"
            primaryButtonIntent={Button.Intent.PRIMARY}
            primaryButtonDisabled={isSubmitting}
            onPrimaryButtonClick={() => {
                (async () => {
                    try {
                        setIsSubmitting(true);
                        await postPaRequest({ intakeCaseId }).unwrap();
                        SuccessToast({ message: 'New prior auth created successfully.' });
                        onClose();
                    } finally {
                        setIsSubmitting(false);
                    }
                })();
            }}
            secondaryButtonLabel="Cancel"
            onSecondaryButtonClick={onClose}
            dialogContent={
                <div className="margin__bottom--medium">
                    Creating a new PA request will archive the current request and start a new one.
                    Are you sure you want to create a new PA request?
                </div>
            }
        />
    );
};
